<!--
 * @Author: luxiangqiang
 * @Date: 2023-02-01 15:01:55
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-02-10 10:19:09
-->
<template>
  <div>
    <PrimaryBanner
      bg-color="#FFECE8"
      bg-image="https://video.reta-inc.com/image/default/4AF9D560F4F04D0489F584D6EC995A40-6-2.png"
      :desc-list="[$t('严密的雇佣合同'), $t('简化的办理流程'), $t('完善的合规担保')]"
      entry="海外雇佣"
      custom-class="banner"
    >
      <template #slogan>
        <div style="max-width: 760px;">
          {{ $t('帮您完成') }}<span style="color: rgba(252, 122, 88, 1)">{{ $t('海外雇佣1') }}</span
          >{{ $t('，让您专注拓展全球业务') }}
        </div>
      </template>
    </PrimaryBanner>
    <div class="main">
      <PrimarySection v-for="(item, index) in content" v-bind="item" :rl="!!(index % 2)" :key="index" />
      <Leads entry="海外雇佣" title="免费获取用工方案" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import content from '@/assets/contents/oversea-employ.json';
useSeoHead();
</script>
<style lang="less" scoped>
.main {
  margin-top: 120px;
  margin-bottom: 160px;
}
// .banner {
//   height: auto;
//   padding-bottom: 80px;
// }

@media screen and (min-width: 800px) {
  .main {
    min-width: 1280px;
    padding: 0 32px;
    :deep(.form-wrapper) {
      display: none;
    }
  }
}

@media screen and (max-width: 800px) {
  .main {
    margin-top: 24px;
    margin-bottom: 40px;
    padding: 0 20px;
    box-sizing: border-box;
    :deep(.form-wrapper) {
      display: block;
      margin: 40px 0 0 0;
      width: 100%;
      .select-service {
        display: none;
      }
    }
  }
}
</style>
